// Centralized feature flags for the client.
//
// These drive UI visibility only (routes, drawer items, component-level guards).
// They do NOT change request shapes or endpoints — the server stays
// backward-compatible for installed Android/iOS apps. See
// docs/SIMPLIFICATION_PLAN.md for the full rollout model.

export const TRANSACTIONS_ENABLED =
  process.env.REACT_APP_TRANSACTIONS_ENABLED === 'true';

export const VIRTUAL_PORTFOLIO_ENABLED =
  process.env.REACT_APP_VIRTUAL_PORTFOLIO_ENABLED === 'true';
